/**
 * SpeecargoTheme - Color Tokens and Constants
 * Centralized theme token definitions for Speedcargo Technologies UI
 */

export type ThemeMode = 'light' | 'dark' | 'speedcargo' | 'twa' | 'panam';

export const THEME_STORAGE_KEY = 'theme-mode';

/**
 * Dark Theme Color Tokens
 */
export const DARK_THEME_TOKENS = {
	// Base colors
	fontSize: 10,
	fontFamily:
		"'Avenir Next LT Pro', AvenirNextLTPro, 'Avenir Next', Avenir, -apple-system, sans-serif",
	colorBgBase: '#000000',
	colorTextBase: '#ffffff',
	colorBorder: '#333333',
	controlOutline: 'transparent',
	controlOutlineWidth: 0,

	// Primary colors
	colorPrimary: '#1890ff',
	colorPrimaryHover: '#40a9ff',
	colorPrimaryActive: '#096dd9',

	// Link colors
	colorLink: '#1890ff',
	colorLinkHover: '#40a9ff',
	colorLinkActive: '#096dd9',

	// Layout
	borderRadius: 0,
} as const;

/**
 * Light Theme Color Tokens
 */
export const LIGHT_THEME_TOKENS = {
	// Base colors
	fontSize: 10,
	fontFamily:
		"'Avenir Next LT Pro', AvenirNextLTPro, 'Avenir Next', Avenir, -apple-system, sans-serif",

	// Primary colors
	colorPrimary: '#1F1F1F',
	colorPrimaryHover: '#333333',
	colorPrimaryActive: '#FFA500',

	// Link colors
	colorLink: '#FFA500',
	colorLinkHover: '#111111',
	colorLinkActive: '#FFA500',

	// Layout
	borderRadius: 0,
} as const;

/**
 * Layout Colors
 */
export const LAYOUT_COLORS = {
	navbar: {
		background: '#1F1F1F',
		height: '50px',
		boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
	},
	content: {
		background: '#0A0C0D',
		marginTop: 35,
		paddingVertical: 24,
	},
	layout: {
		background: '#0A0C0D',
		minHeight: '100vh',
	},
} as const;
